import { Box, Typography, Container } from "@mui/material";
import { useProgramContext } from "@/context/ProgramContext";
import { ProgramMediaCard } from "./ProgramMediaCard";
import { useEffect, useState } from "react";
import { TaskerConfig } from "@t3/shared";
import { doc, getDoc } from "firebase/firestore";
import { firestore } from "@/firebase";
import { useAuthContext } from "@/context/AuthContext";
import { taskerConfigConverter } from "../../../converters";

// const mockRewardOptions: TaskerRewardOption[] = [
//   {
//     id: "bronze-tier",
//     label: "Bronze Tier",
//     description: "Complete 5 display cases to earn Bronze tier rewards",
//     type: "points",
//     amount: 100,
//   },
//   {
//     id: "silver-tier",
//     label: "Silver Tier",
//     description: "Complete 15 display cases to unlock Silver tier rewards",
//     type: "points",
//     amount: 250,
//   },
//   {
//     id: "gold-tier",
//     label: "Gold Tier",
//     description: "Complete 30 display cases to achieve Gold tier status",
//     type: "points",
//     amount: 500,
//   },
//   {
//     id: "platinum-tier",
//     label: "Platinum Tier",
//     description: "Complete 50 display cases to reach Platinum tier status",
//     type: "points",
//     amount: 1000,
//   },
// ];

export const TaskerProgramsPage = () => {
  const { programs, loading } = useProgramContext();
  const { user } = useAuthContext();
  const [taskerConfigs, setTaskerConfigs] = useState<
    Record<string, TaskerConfig>
  >({});
  const [optionsLoading, setOptionsLoading] = useState(true);

  useEffect(() => {
    const fetchFeatureData = async () => {
      try {
        const data: Record<string, TaskerConfig> = {};
        for (const program of programs) {
          const taskerFeatureQuery = doc(
            firestore,
            `company/${user.company}/programs/${program.id}/features/tasker`,
          ).withConverter(taskerConfigConverter);
          const docRef = await getDoc(taskerFeatureQuery);
          const docData = docRef.data();
          if (docData && docData.status === "active") {
            data[program.id] = docData;
          }
        }
        setTaskerConfigs(data);
      } catch (error) {
        console.error("Error fetching feature data:", error);
      } finally {
        setOptionsLoading(false);
      }
    };

    if (!loading && programs.length > 0) {
      fetchFeatureData();
    }
  }, [programs, loading, user.company]);

  return (
    <Box
      sx={{
        mx: { xs: -2, sm: 0 },
      }}
    >
      <Container
        maxWidth="xl"
        disableGutters
        sx={{
          px: { xs: 0, sm: 3 },
          alignItems: "center",
        }}
      >
        {loading || optionsLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <Typography variant="body1" color="text.secondary">
              Loading programs...
            </Typography>
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: { xs: 2, sm: 3, md: 4 },
            }}
          >
            {Object.entries(taskerConfigs).map(([programId, taskerConfig]) => {
              return <ProgramMediaCard key={programId} config={taskerConfig} />;
            })}
          </Box>
        )}
      </Container>
    </Box>
  );
};
